import { render, staticRenderFns } from "./company_validations.vue?vue&type=template&id=6b5877be&"
import script from "./company_validations.vue?vue&type=script&lang=js&"
export * from "./company_validations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports